module.exports = __webpack_public_path__ + "static/export.0d7ed364ccc69cc4e30d2719a8c6e3f3.svg";